import { clientAxios8080 } from "../configs/axios";

// FOLDER

export const getDirectoryMain = (idUsuario, userRole) => {
  return new Promise((resolve, reject) => {
    clientAxios8080
      .get(`/ms-repositorio/app/structure/directory/get`, { params: { role: userRole, idUsuario}})
      .then((response) => {
        resolve(response.data.data.root.children);
      })
      .catch((error) => reject(error));
  });
};

export const getFolderInfo = (folderId,idUsuario ) => {
  return new Promise((resolve, reject) => {
    clientAxios8080
      .get(
        `/ms-repositorio/app/structure/childs/directory/get?idCarpetaPadre=${folderId}`, { params: { idUsuario}})
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((error) => reject(error));
  });
};

// FILE

export const getFileInfo = (fileId) => {
  return new Promise((resolve, reject) => {
    clientAxios8080
      .get(`/ms-repositorio/file/find/document?documentId=${fileId}`)
      .then((response) => {
        resolve(response.data.data[0]);
      })
      .catch((error) => reject(error));
  });
};

export const downloadFile = (fileId) => {
  return new Promise((resolve, reject) => {
    clientAxios8080
      .get(`/ms-repositorio/file/downloadFile?id=${fileId}`)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => reject(error));
  });
};

export const updateDocumentStatus = (fileId, status, message) => {
  console.log("message", message);
  return new Promise((resolve, reject) => {
    clientAxios8080
      .put(
        `/ms-repositorio/file/updateStatus/document?idFile=${fileId}&idFileStatus=${status}&comentario=${message}`
      )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => reject(error));
  });
};

export const deleteResource = (idResource, resourceType) => {
  return new Promise((resolve, reject) => {
    clientAxios8080
      .post(`/ms-repositorio/app/delete/resource?idResource=${idResource}&resourceType=${resourceType}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => reject(error));
  });
};
